// extracted by mini-css-extract-plugin
module.exports = {"floating":"ItemFloatingAction_floating__29jwP","button":"ItemFloatingAction_button__3bqjQ","link":"ItemFloatingAction_link__3MW8w"};